<script>
import VideoTile from './VideoTile';
import VideoLoading from './VideoLoading';
import { mapGetters } from 'vuex';
import Carousel from '../Carousel/Carousel.vue';
import { createVideoUrl, createPlaylistUrl } from '../../utils/slugUtils';

export default {
  name: 'VideoTiles',
  components: {
    VideoTile,
    VideoLoading,
    Carousel,
  },
  data() {
    return {
      homepagePlaylistId: '6001804917001',
      containerWidth: '',
      tileType: '',
      mobileTileLimit: 4,
    };
  },
  computed: {
    ...mapGetters({
      playlist: 'VideoTiles/getVideoPlaylist',
    }),
    playlistVideos() {
      const { playlist } = this;
      return playlist ? playlist.videos : [];
    },
    playlistName() {
      const { playlist } = this;
      return playlist ? playlist.name : false;
    },
    videosExist() {
      const { playlistVideos } = this;
      return playlistVideos ? this.playlistVideos.length > 0 : false;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    const { $store: store, homepagePlaylistId, setContainerWidth } = this;
    store.dispatch('VideoTiles/fetchPlaylist', homepagePlaylistId);
    // keep track of container width and display different components depending on size
    setContainerWidth();
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    setContainerWidth() {
      const TILE_TYPE_BREAKPOINT = 786;
      this.containerWidth = this.$refs.videoTilesContainer.offsetWidth;
      this.tileType = this.containerWidth > TILE_TYPE_BREAKPOINT ? 'square' : 'rectangle';
    },
    handleResize() {
      this.setContainerWidth();
    },
    updateLimit() {
      this.mobileTileLimit += +4;
    },
    videoUrl(playlistName, videoObject) {
      return createVideoUrl(playlistName, videoObject);
    },
    categoryUrl(playlistName) {
      return createPlaylistUrl(playlistName);
    },
  },
};
</script>

<template>
  <div class="video-tiles__wrapper">
    <div ref="videoTilesContainer">
      <!-- Loading state -->      
      <VideoLoading v-if="!videosExist" />

      <!-- Desktop carousel -->
      <Carousel
        v-else-if="videosExist && tileType == 'square'"
        :tiles-per-slide="4"
        :carousel-height="320"
        :total-tiles="playlistVideos.length"
        :gap="0"
        :title="playlistName ? playlistName : 'Video'"
        :link="`${categoryUrl(playlistName)}`"
      >
        <template v-for="(video, index) in playlistVideos">
          <VideoTile
            :key="`video-tile-${index}`"
            :video-id="video.id"
            :video-title="video.title"
            :link="`${videoUrl(playlistName, video)}`"
            :video-image-url="video.images.thumbnail"
            :video-duration="video.duration"
            :video-published-at="video.published_at"
            :tile-type="'square'"
          />
        </template>
      </Carousel>

      <!-- Mobile tiles -->
      <div v-else class="video-tiles__container">
        <h2 class="video-tiles__title">Video</h2>
        <VideoTile
          v-for="(video, index) in playlistVideos.slice(0, mobileTileLimit)"
          :key="`video-tile-${index}-limit-${mobileTileLimit}`"
          :video-id="video.id"
          :video-title="video.title"
          :link="`${videoUrl(playlistName, video)}`"
          :video-image-url="video.images.thumbnail"
          :video-duration="video.duration"
          :video-published-at="video.published_at"
          :tile-type="tileType"
        />
        <a class="video-tile-show-more" href="#" @click.prevent="updateLimit">
          <span>More Video</span>
        </a>
      </div>
    </div>
  </div>
</template>
